import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RetournerDossierModalComponent } from 'src/app/formulaire/modal/retourner-dossier-modal/retourner-dossier-modal.component';
import { Corporate } from 'src/app/parametrage/core/model/corporate';
import { CorporateService } from '../../core/service/corporate.service';

@Component({
  selector: "app-formulaire-layout",
  templateUrl: "./formulaire-layout.component.html",
  styleUrls: ["./formulaire-layout.component.scss"],
})
export class FormulaireLayoutComponent implements OnInit {
  requestId: string;
  taskId: string;

  dossier: Request;
  corporate : Corporate;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private _requestService: RequestService,
    private _corporateService: CorporateService
  ) {
    console.log("Current URL:", _router.url);

    console.log("requestId:", _router.url.split("/")[3]);
    this.requestId = this._router.url.split("/")[3];

    console.log("taskId:", _router.url.split("/")[4]);
    this.taskId = this._router.url.split("/")[4];
  }

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.getCorporateByRequestId(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  getCorporateByRequestId(requestId)
  {
    this._corporateService.getCorporateByRequestId(requestId)
    .subscribe(
        data => {
          this.corporate =  data;
        },
        error => {
          console.log(error);
        });
  }

  retourner()
  {
    const modalRef = this.modalService.open(RetournerDossierModalComponent,{centered:true});
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then((data) => {
      // on close
      if(data != "Close click"){
        this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
      }
        
      }, (reason) => {
      // on dismiss
      });

  }

}
